import { render, staticRenderFns } from "./formPassword.vue?vue&type=template&id=dd0c05a4&"
import script from "./formPassword.vue?vue&type=script&lang=js&"
export * from "./formPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports